import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/apiClient';

/** 全平台「生产工厂」名称池（后端持久化，填过的之后都可选） */
export function useFactoryNames() {
  return useQuery({
    queryKey: ['factory-names'],
    queryFn: () => api.get<{ names: string[] }>('/factory-names').then((r) => r.names),
    staleTime: 60_000,
  });
}

/** 给 AutoComplete 用的选项 */
export function useFactoryNameOptions(): { value: string }[] {
  const q = useFactoryNames();
  return (q.data ?? []).map((v) => ({ value: v }));
}
